import React, { useState, useEffect } from 'react'
import s from '@pagestyles/Blog.module.scss'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import Image from '@corratech/pylot-image'
import getRelatedPost, {
    RelatedBlogPost,
    RelatedBlogPostParams,
    RelatedPostDetails
} from '@pylot-data/api/operations/get-blogreleatedpost'
import { authorTime } from '@components/common/CMSBlockConst/cms-block-util'
import { useRouter } from 'next/router'
const RelatedPost = (props: RelatedBlogPostParams) => {
    const { t } = useTranslation(['blog'])
    const [relatedPosts, setRelatedPosts] = useState<RelatedBlogPost>()
    const posturlbannerlink = '/blog/'
    const router = useRouter()
    const { locale } = router
    useEffect(() => {
        const getRelatedPostData = async () => {
            const blogData = await getRelatedPost({
                postId: props.postId,
                locale: locale || ''
            })
            if (!blogData) {
                return {
                    notFound: true
                }
            }
            await setRelatedPosts(blogData.blogPost)
        }

        getRelatedPostData()
    }, [props.postId])

    return (
        <div>
            {relatedPosts?.related_posts &&
                relatedPosts.related_posts.length !== 0 && (
                    <div className={s['popularPost']}>
                        <h2>{t('Related Post')}</h2>
                        <div className={s['popularPost']}>
                            {relatedPosts.related_posts.map(
                                (relatedPost: RelatedPostDetails) => {
                                    return (
                                        <div
                                            className={s['popularList']}
                                            key={relatedPost?.title}
                                        >
                                            <div
                                                className={s['popularpostImg']}
                                            >
                                                <Link
                                                    href={`${posturlbannerlink}${relatedPost?.identifier}`}
                                                >
                                                    <Image
                                                        src={
                                                            relatedPost?.featured_list_image
                                                        }
                                                        width={920}
                                                        height={625}
                                                        alt={relatedPost?.title}
                                                    />
                                                </Link>
                                            </div>
                                            <div
                                                className={
                                                    s['popularpostcontent']
                                                }
                                            >
                                                <Link
                                                    href={`${posturlbannerlink}${relatedPost?.identifier}`}
                                                >
                                                    {relatedPost?.title}
                                                </Link>
                                                <p>{authorTime(relatedPost)}</p>
                                            </div>
                                        </div>
                                    )
                                }
                            )}
                        </div>
                    </div>
                )}
        </div>
    )
}

export default RelatedPost
